import { createClient} from '@supabase/supabase-js'
const supabaseUrl = "https://ntyoyfrscvufcrodsrdn.supabase.co" ;

const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im50eW95ZnJzY3Z1ZmNyb2RzcmRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNTgwNzcsImV4cCI6MjA3NTkzNDA3N30.wOIqML5qOWJHJglvMTpkyzAKy1v33ZaU7uEOojKId0Y"
export const supabase = createClient(supabaseUrl, supabaseKey);